import { render, staticRenderFns } from "./addOrEditProject.vue?vue&type=template&id=5cc8e309&scoped=true"
import script from "./addOrEditProject.vue?vue&type=script&lang=js"
export * from "./addOrEditProject.vue?vue&type=script&lang=js"
import style0 from "./addOrEditProject.vue?vue&type=style&index=0&id=5cc8e309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc8e309",
  null
  
)

export default component.exports